// src/components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">
          <img src="https://rekxup.s3.us-east-2.amazonaws.com/Public/Screen+Shot+2024-03-07+at+8.41.39+PM.png" alt="rekxup" className="logo" />
        </div>
        <div className="footer-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <a href="mailto:contact@rekxup.com">Contact Us</a>
        </div>
        <div className="footer-copyright">
          © {currentYear} Rekxup. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;